$(window).on("load", function () {
    // 针对每个 image-comparator 初始化
    $(".image-comparator").each(function (i, item) {
        initImageComparator(item, {
            handleClass: "handle",
            imgAfterClass: "img-after",
            initialPosition: 0.5 // 初始位置为 50%
        });
    });

    // 初始化函数，负责图片比较器的行为
    function initImageComparator(element, options = {}) {
        const $comparator = $(element); // 获取比较器容器
        const config = {
            initialPosition: 0.5, // 默认初始位置
            handleClass: "handle", // 拖动条类名
            imgAfterClass: "img-after", // 后面图片的类名
            ...options
        };

        const $handle = $comparator.find("." + config.handleClass); // 拖动条
        const $imgAfter = $comparator.find("." + config.imgAfterClass); // 后面图片

        let isDragging = false; // 用于标记是否正在拖动
        let comparatorWidth = 0; // 用于存储比较器宽度

        // ==========================
        // 初始化宽度和位置
        // ==========================
        function initWidthAndPosition() {
            comparatorWidth = $comparator.width(); // 获取比较器的宽度

            if (!comparatorWidth || comparatorWidth <= 0) return;

            const handlePos = comparatorWidth * config.initialPosition; // 计算初始位置
            $handle.css("left", handlePos); // 设置拖动条初始位置
            updateClipPath(handlePos); // 更新图片剪裁
        }

        // ==========================
        // 更新剪裁区域
        // ==========================
        function updateClipPath(position) {
            const clipX = (position / comparatorWidth) * 100; // 计算剪裁百分比
            $imgAfter.css("clip-path", `polygon(0 0, ${clipX}% 0, ${clipX}% 100%, 0 100%)`); // 设置剪裁区域
        }

        // ==========================
        // 更新拖动条位置
        // ==========================
        function updatePosition(clientX) {
            const rect = $comparator[0].getBoundingClientRect(); // 获取比较器的位置
            const offsetX = clientX - rect.left; // 计算鼠标在比较器内的位置

            let newPos = Math.max(0, Math.min(offsetX, comparatorWidth)); // 确保位置在比较器范围内

            // 避免拖动条出界，给它留 20px 的边距
            if (newPos < 20 || newPos > comparatorWidth - 20 - $handle.width()) return;

            $handle.css("left", newPos); // 更新拖动条的位置
            updateClipPath(newPos); // 更新图片剪裁
        }

        // ==========================
        // 鼠标事件
        // ==========================
        $handle.on("mousedown", function (e) {
            isDragging = true; // 开始拖动
            $("body").css("cursor", "ew-resize"); // 修改光标样式
            e.preventDefault();
        });

        $(document).on("mousemove", function (e) {
            if (isDragging) updatePosition(e.clientX); // 拖动时更新位置
        });

        $(document).on("mouseup", function () {
            isDragging = false; // 停止拖动
            $("body").css("cursor", ""); // 恢复光标样式
        });

        // ==========================
        // 触摸事件
        // ==========================
        $handle.on("touchstart", function (e) {
            isDragging = true; // 开始拖动
            e.preventDefault();
        });

        $(document).on("touchmove", function (e) {
            if (!isDragging) return;
            const touch = e.originalEvent.touches[0];
            updatePosition(touch.clientX); // 更新触摸时的位置
        });

        $(document).on("touchend", function () {
            isDragging = false; // 停止拖动
        });

        // ==========================
        // 窗口大小改变时重新计算
        // ==========================
        $(window).on("resize", function () {
            initWidthAndPosition(); // 重新计算初始化位置
        });

        // ==========================
        // 图片完全加载后初始化位置
        // ==========================
        const imgs = $comparator.find("img"); // 获取所有图片
        let loaded = 0; // 计数器，确保所有图片加载完成

        // 遍历每个图片，确保它们加载完成后再初始化位置
        imgs.each(function () {
            if (this.complete) {
                loaded++;
                if (loaded === imgs.length) initWidthAndPosition(); // 所有图片加载完后初始化位置
            } else {
                $(this).on("load", function () {
                    loaded++;
                    if (loaded === imgs.length) initWidthAndPosition(); // 所有图片加载完后初始化位置
                });
            }
        });

        // fallback（防止没有触发 load 事件）在 500ms 后强制初始化位置
        setTimeout(initWidthAndPosition, 500);
    }
});
